import { useEffect, useState } from 'react';
import { Dropdown, Form } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Header from '../componets/Layout/Header';
import Sidebar from '../componets/Layout/Sidebar';
import { UserValidateFields } from '../componets/validate/userValidation';
import { editEntryForm, getTemplateByCategories } from '../controller';
import { requestHandler } from '../helper';
import ErrorFilter from '../helper/errorFilter';
import SingleError from '../helper/SingleError';

function EditEntryFormManagement() {


  const location = useLocation();
  let { data, categoryData, templateData } = location?.state


  const requireField = ["companyName", "vendorSuite", "categoryId", "templateId"];
  const [pages, setPages] = useState(data?.header || [{ id: Date.now() }]);
  const [categoryId, setCategoryId] = useState(data?.categoryId._id || "");
  const [templateId, setTemplateId] = useState(data?.templateId._id || "");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [errors, setErrors] = useState({});
  const [submitCount, setSubmitCount] = useState(0);
  const [tempData, setTempData] = useState([]);
  const [currentPageIndex, setCurrentPageIndex] = useState(null);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    companyName: data?.companyName || "",
    companyMotto: data?.companyMotto || '',
    companyLogo: data?.companyLogo || "",
    watermark: data?.watermark || '',
    tag5: data?.tag5 || '',
    vendorSuit: data?.vendorSuit || '',
    categoryId: data?.categoryId || null,
    templateId: data?.templateId || null,
  });

  useEffect(() => {
    // Set the selectedCategory based on the categoryId
    const category = categoryData.find(cat => cat._id === categoryId);
    setSelectedCategory(category || null);

    // Set the selectedTemplate based on the templateId
    const template = templateData.find(temp => temp._id === templateId);
    setSelectedTemplate(template?.name || null);
  }, [categoryId, categoryData]);

  const handleAddPage = () => {
    setPages([...pages, { headerLeft: '', headerCenter: '', headerRight: '', disclaimer: '', footerLeft: '', footerRight: '' }]);
  };


  // Function to delete a page (header)
  const handleDeletePage = (index) => {
    setPages(pages?.filter((_, i) => i !== index)); // Remove the page by index
  };
  const handleInputChange = (e) => {
    const { name, value, checked, type } = e.target;

    // Determine the new value based on input type
    const newValue = type === 'checkbox' ? checked : value;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (submitCount > 0) {
      let validationErrors = UserValidateFields({ ...formData, [name]: newValue });
      validationErrors = ErrorFilter(validationErrors, requireField);
      setErrors(validationErrors);
    }
  };

  const handleHeaderChange = (index, field, value) => {
    const newPages = [...pages];
    newPages[index] = {
      ...newPages[index],
      [field]: value,
    };
    setPages(newPages);
    setCurrentPageIndex(index);
  };


  const getTempData = async () => {
    if (!categoryId) {
      // Handle case where categoryId is not set
      console.error("Category ID is required");
      return;
    }
    await requestHandler(
      async () => await getTemplateByCategories(categoryId),
      null,
      (res) => {
        setTempData(res.data.templates);
      },
      () => { }
    );
  };

  const handleSubmit = async () => {
    setSubmitCount((prevCount) => prevCount + 1);
    let validationErrors = UserValidateFields(formData);
    validationErrors = ErrorFilter(validationErrors, requireField);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      // Prepare the request body
      const requestBody = {
        companyName: formData.companyName,
        companyMotto: formData.companyMotto,
        companyLogo: formData.companyLogo,
        watermark: formData.watermark,
        tag5: formData.tag5,
        vendorSuit: formData.vendorSuit,
        categoryId: categoryId,
        templateId: templateId,
      };

      // Check if index is passed and if you want to update headers
      if (currentPageIndex !== undefined) {
        requestBody.headerLeft = pages[currentPageIndex]?.headerLeft || "";
        requestBody.headerCenter = pages[currentPageIndex]?.headerCenter || "";
        requestBody.headerRight = pages[currentPageIndex]?.headerRight || "";
        requestBody.disclaimer = pages[currentPageIndex]?.disclaimer || "";
        requestBody.footerLeft = pages[currentPageIndex]?.footerLeft || "";
        requestBody.footerRight = pages[currentPageIndex]?.footerRight || "";
      }


      await requestHandler(
        async () => await editEntryForm(requestBody, location.state.data._id, currentPageIndex !== -1 ? currentPageIndex : undefined),
        null,
        (res) => {
          toast.success(res.message);
          // Reset form data
          setFormData({
            companyName: "",
            companyMotto: '',
            companyLogo: "",
            watermark: '',
            tag5: '',
            vendorSuit: '',
            categoryId: null,
            templateId: null,
          });
          setTempData([]);
          navigate('/entry-form');
          setSubmitCount(0);
        },
        () => {
          setSubmitCount(0);
        }
      );
    }
  };

  return (
    <>
      <div className='layouy-main'>
        <div className='sidebar-hide-show'>
          <Sidebar />
        </div>
        <div className='w-100'>
          <Header />
          <div className="tebs-title">
            <p className='active'>Entry Form Management</p>
          </div>
          <section className='px-20'>
            <div className="card border-bottom-0 rounded-bottom-0">
              <div className="card-header bg-transparent p-3">
                <div className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2'>
                  <h4 className='add-title'>Edit Entry Form</h4>
                  <Link to='/entry-form' className='back-btn d-flex align-items-center gap-3 text-decoration-none'><img src="../images/png/left.png" width={8} alt="" /><p className='mb-0'>Back</p></Link>
                </div>
              </div>
              <div className="card-body px-20">
                <div className="card border-0">
                  <div className="card-body p-0">
                    <div className='modal-form pt-0'>
                      <Form className='row'>
                        <div className='col-12 col-md-12 col-xl-4'>
                          <Form.Group className="mb-3" controlId="formGroupEmail">
                            <Form.Label>Company Name*</Form.Label>
                            <Form.Control
                              type="text"
                              name="companyName"
                              value={formData.companyName}
                              onChange={handleInputChange}
                              placeholder="Add Company Name"
                            />
                          </Form.Group>
                          <SingleError error={errors?.companyName} />
                        </div>
                        <div className='col-12 col-md-12 col-xl-4'>
                          <Form.Group className="mb-3" controlId="formGroupEmail">
                            <Form.Label>Company Motto</Form.Label>
                            <Form.Control
                              type="text"
                              name="companyMotto"
                              value={formData.companyMotto}
                              onChange={handleInputChange}
                              placeholder="Enter Company Motto"
                            />
                          </Form.Group>
                        </div>
                        <div className='col-12 col-md-12 col-xl-4'>
                          <Form.Group className="mb-3" controlId="formGroupEmail">
                            <Form.Label>Company Logo</Form.Label>
                            <Form.Control
                              type="text"
                              name="companyLogo"
                              value={formData.companyLogo}
                              onChange={handleInputChange}
                              placeholder="Enter Company Logo"
                            />
                          </Form.Group>
                        </div>
                        <div className='col-12 col-md-12 col-xl-4'>
                          <Form.Group className="mb-3" controlId="formGroupEmail">
                            <Form.Label>WaterMark</Form.Label>
                            <Form.Control
                              type="text"
                              name="watermark"
                              value={formData.watermark}
                              onChange={handleInputChange}
                              placeholder="Enter WaterMark"
                            />
                          </Form.Group>
                        </div>
                        <div className='col-12 col-md-12 col-xl-4'>
                          <Form.Group className="mb-3" controlId="formGroupEmail">
                            <Form.Label>Tag 5</Form.Label>
                            <Form.Control
                              type="text"
                              name="tag5"
                              value={formData.tag5}
                              onChange={handleInputChange}
                              placeholder="Enter Tag 5"
                            />
                          </Form.Group>
                        </div>
                        <div className='col-12 col-md-12 col-xl-4'>
                          <Form.Group className="mb-3" controlId="formGroupPassword">
                            <Form.Label>Vendor Suite*</Form.Label>
                            <Dropdown className='status-btn'>
                              <Dropdown.Toggle>
                                {formData.vendorSuit || 'Select Vendor Suite'}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item onClick={() => setFormData({ ...formData, vendorSuit: 'Adobe' })}>Adobe</Dropdown.Item>
                                <Dropdown.Item onClick={() => setFormData({ ...formData, vendorSuit: 'Microsoft' })}>Microsoft</Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </Form.Group>
                        </div>


                        <div className='col-12'>
                          <Form.Group className="mb-2" controlId="formGroupEmail">
                            <Form.Label>Pages</Form.Label>
                          </Form.Group>

                          {/* Loop over the pages array to render each card */}
                          {pages.map((page, index) => (
                            <div className="card mb-3" key={page.id}>
                              <div className="card-body">
                                <Form.Group className="mb-3" controlId={`formGroupPage${index}`}>
                                  <Form.Label>Page {index + 1}</Form.Label>
                                </Form.Group>
                                <div className="row">
                                  <div className='col-12 col-md-12 col-xl-4'>
                                    <Form.Group className="mb-3" controlId={`formGroupHeaderLeft${index}`}>
                                      <Form.Label>Header Left</Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter Header Left"
                                        value={page.headerLeft || ''}
                                        onChange={(e) => handleHeaderChange(index, 'headerLeft', e.target.value)}
                                      />
                                    </Form.Group>
                                  </div>
                                  <div className='col-12 col-md-12 col-xl-4'>
                                    <Form.Group className="mb-3" controlId={`formGroupHeaderCenter${index}`}>
                                      <Form.Label>Header Center</Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter Header Center"
                                        value={page.headerCenter || ''}
                                        onChange={(e) => handleHeaderChange(index, 'headerCenter', e.target.value)}
                                      />
                                    </Form.Group>
                                  </div>
                                  <div className='col-12 col-md-12 col-xl-4'>
                                    <Form.Group className="mb-3" controlId={`formGroupHeaderRight${index}`}>
                                      <Form.Label>Header Right</Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter Header Right"
                                        value={page.headerRight || ''}
                                        onChange={(e) => handleHeaderChange(index, 'headerRight', e.target.value)}
                                      />
                                    </Form.Group>
                                  </div>
                                  <div className='col-12 col-md-12 col-xl-4'>
                                    <Form.Group className="mb-3" controlId={`formGroupDisclaimer${index}`}>
                                      <Form.Label>Disclaimer</Form.Label>
                                      {/* <FloatingLabel controlId={`floatingTextarea${index}`} label="Enter Disclaimer"> */}
                                      <Form.Control
                                        as="textarea"
                                        placeholder="Enter Disclaimer"
                                        style={{ height: '100px' }}
                                        value={page.disclaimer || ''}
                                        onChange={(e) => handleHeaderChange(index, 'disclaimer', e.target.value)}
                                      />
                                      {/* </FloatingLabel> */}
                                    </Form.Group>
                                  </div>
                                  <div className='col-12 col-md-12 col-xl-4'>
                                    <Form.Group className="mb-3" controlId={`formGroupFooterLeft${index}`}>
                                      <Form.Label>Footer Left</Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter Footer Left"
                                        value={page.footerLeft || ''}
                                        onChange={(e) => handleHeaderChange(index, 'footerLeft', e.target.value)}
                                      />

                                    </Form.Group>
                                  </div>
                                  <div className='col-12 col-md-12 col-xl-4'>
                                    <Form.Group className="mb-3" controlId={`formGroupFooterRight${index}`}>
                                      <Form.Label>Footer Right</Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter Footer Right"
                                        value={page.footerRight || ''}
                                        onChange={(e) => handleHeaderChange(index, 'footerRight', e.target.value)}
                                      />
                                    </Form.Group>
                                  </div>
                                </div>

                                <div className='d-flex justify-content-end'>
                                  {/* Delete Button */}
                                  {pages.length > 1 && (
                                    <button className='delete-link add-link bg-danger' onClick={() => handleDeletePage(index)}>
                                      <p className='m-0'>Delete Page</p>
                                    </button>
                                  )}
                                </div>

                              </div>
                            </div>
                          ))}

                          {/* Add Page Button */}
                          <div className='d-flex justify-content-end mt-3 mb-5'>
                            <div className='add-link' onClick={handleAddPage}>
                              <img src="../images/png/plush.png" width={12} height={12} alt="" />
                              <p className='m-0'>Add Pages</p>
                            </div>
                          </div>
                        </div>

                        <div className='col-12 col-md-12 col-xl-4'>
                          <Form.Group className="mb-3" controlId="formGroupPassword">
                            <Form.Label>Category*</Form.Label>
                            <Dropdown className='status-btn'>

                              <Dropdown.Toggle>
                                {selectedCategory ? selectedCategory.name : "Select Category"}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {categoryData?.map(category => (
                                  <Dropdown.Item key={category._id} onClick={() => {
                                    setCategoryId(category._id);
                                    setSelectedCategory(category);
                                    setSelectedTemplate(null);
                                    setTemplateId(null);
                                    setFormData({
                                      ...formData,
                                      categoryId: category._id,
                                      templateId: null
                                    })
                                    delete errors.categoryId;
                                    setErrors({ ...errors });
                                    getTempData();
                                  }}>
                                    {category.name}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </Form.Group>
                          <SingleError error={errors?.categoryId} />
                        </div>
                        <div className='col-12 col-md-12 col-xl-4'>
                          <Form.Group className="mb-3" controlId="formGroupPassword">
                            <Form.Label>Template*</Form.Label>
                            <Dropdown className='status-btn'>
                              <Dropdown.Toggle>
                                {selectedTemplate ? selectedTemplate : "Select Template"}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {tempData.map((temp, index) => (
                                  <Dropdown.Item
                                    key={index}
                                    onClick={() => {
                                      setTemplateId(temp._id);
                                      setSelectedTemplate(temp.name);
                                      setFormData({
                                        ...formData,
                                        templateId: temp._id
                                      })
                                      delete errors.templateId;
                                      setErrors({ ...errors });
                                    }}
                                  >
                                    {temp.name}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </Form.Group>
                          <SingleError error={errors?.templateId} />
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
                <div className="row justify-content-end">
                  <div className="col-12 col-md-3 col-xl-2">
                    <div className='d-md-flex justify-content-end align-items-center gap-3 my-4'>
                      {/* <button className='cancel-btn' type='button'>Cancel</button> */}
                      <button className='save-btn' type='button' onClick={handleSubmit}>Submit</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  )
}

export default EditEntryFormManagement